export const FaultCreateSceneTranslation = {
  fi: {
    FaultCreateScene: {
      title: 'Luo uusi vikailmoitus',
    },
  },
};
